import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import {
  resetConfiguration,
  resetErrors,
  setLpco,
  setLpcoIsFetched,
  setParentLpco,
  setSelectedLicenseTypeId,
  setUserReferenceNumber,
} from '../store/slice';

function useLicenseCleanupFunction() {
  const dispatch = useDispatch();

  return useCallback(() => {
    dispatch(setLpco(null));
    dispatch(setSelectedLicenseTypeId(null));
    dispatch(resetConfiguration());
    dispatch(setUserReferenceNumber(null));
    dispatch(resetErrors());
    dispatch(setLpcoIsFetched(false));
    dispatch(setParentLpco(null));
  }, [dispatch]);
}

export default useLicenseCleanupFunction;
